<div class="overlay">
    <div class="overlay__inner">
        <div class="overlay__content"><mat-spinner></mat-spinner></div>
    </div>
</div>
